import { type FC } from 'react'
import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import styles from './styles.module.scss'

type IForwardToAnotherInboxProps = {
  info: Inbox
}

export const ForwardToAnotherInbox: FC<IForwardToAnotherInboxProps> = ({ info: { name } }) => {
  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.wrapIcon)}>
        <Icon icon={'inboxOpen'} fontSize={16} />
      </div>
      <Typography
        tag={'div'}
        variant={'body-sm-regular'}
        color={'var(--content-primary-primary)'}
        ariaLabel={'forward_to_another_inbox'}
        tooltipProps={{
          label: name,
        }}
        ellipsis
      >
        Forwarded to “{name}”
      </Typography>
    </div>
  )
}
